import BaseModal from '@/modal/baseModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '@/assets/images/bankLogo.png';
import FrenchFlag from '@/assets/images/frenchFlag.png';
import EnglishFlag from '@/assets/images/englishFlag.png';
import PortugalFlag from '@/assets/images/portugalFlag.png';
import i18n from 'i18next';
import Button from '@/ui-kit/Button';
import clsx from 'clsx';
import styles from './styles.module.scss';
import SubmitButton from '@/ui-kit/SubmitButton';
import { getDefaultLanguage, getSupportedLanguages } from '@/utils/languageConfig';

const LANGUAGE_FLAGS: Record<string, { icon: string; labelKey: string }> = {
  fr: { icon: FrenchFlag, labelKey: 'general.french' },
  en: { icon: EnglishFlag, labelKey: 'general.english' },
  pt: { icon: PortugalFlag, labelKey: 'general.portuguese' },
};

export const InitialLanguageModal = () => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(!localStorage.getItem('language'));
  const defaultLang = getDefaultLanguage();
  const [language, setLanguage] = useState(defaultLang);

  const handleSubmitLanguage = () => {
    localStorage.setItem('language', language);
    setModalOpen(false);
    i18n.changeLanguage(language);
  };

  const supportedLanguages = getSupportedLanguages();
  const languagesItems = supportedLanguages
    .filter(lang => LANGUAGE_FLAGS[lang])
    .map(lang => ({
      id: `${lang}Button`,
      icon: LANGUAGE_FLAGS[lang].icon,
      language: lang,
      label: t(LANGUAGE_FLAGS[lang].labelKey),
    }));

  return (
    <>
      {modalOpen && (
        <BaseModal onClose={() => {}} width='480px' hideCloseIcon={true}>
          <div className='mt-8 mx-6 mb-6'>
            <img src={Logo} alt='Logo' className='w-[63px] ml-auto mr-auto self-center mb-6' />
            <h5 className='text-center mb-4 text-[var(--text-primary)]'>{t('general.welcome')}</h5>
            <p className='body2s text-center'>{t('general.welcomeDesc')}</p>
            <div className='flex mt-6 gap-6'>
              {languagesItems.map(languageItem => (
                <Button
                  key={languageItem.id}
                  id={languageItem.id}
                  icon={languageItem.icon}
                  inputStyle={clsx('w-full flex justify-start', language === languageItem.language && styles.selectedLanguage)}
                  label={languageItem.label}
                  onClick={() => {
                    setLanguage(languageItem.language);
                    i18n.changeLanguage(languageItem.language);
                  }}
                />
              ))}
            </div>
            <SubmitButton
              inputStyle='mt-6'
              label={t('general.saveAndContinue')}
              onClick={() => handleSubmitLanguage()}
              id='saveLanguageButton'
            />
          </div>
        </BaseModal>
      )}
    </>
  );
};
